import { render } from "./ContactForm.vue?vue&type=template&id=0c6a5ee4"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__